/**
 * Flipnovel 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Flipnovel 品牌特定主题配置
 * 深色主题，紫色主色调
 */
export const theme = {
  // 引用装饰线颜色
  quoteColor: 'rgba(255, 107, 61, 0.35)',
  // 目录弹窗中锁图标的颜色
  tocLockColor: brandTheme.primaryColor,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
